<template>
  <section class="phone-task-state" :aria-labelledby="titleId">
    <h2 :id="titleId" class="phone-task-state__title">{{ title }}</h2>
    <p v-if="text" class="phone-task-state__text">{{ text }}</p>
    <router-link
      v-if="actionLabel && actionTo"
      :to="actionTo"
      class="phone-task-state__action"
      data-testid="phone-task-state-action"
    >
      {{ actionLabel }}
    </router-link>
    <button
      v-else-if="actionLabel"
      type="button"
      class="phone-task-state__action"
      data-testid="phone-task-state-action"
      @click="emit('action')"
    >
      {{ actionLabel }}
    </button>
  </section>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    default: "",
  },
  actionLabel: {
    type: String,
    default: "",
  },
  actionTo: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["action"]);

const titleId = computed(
  () => `phone-task-state-${props.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`
);
</script>

<style scoped>
.phone-task-state {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 32px 16px;
  text-align: center;
  font-family: "Inter", sans-serif;
}

.phone-task-state__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #101828;
}

.phone-task-state__text {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #344054;
}

.phone-task-state__action {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 48px;
  padding: 14px 20px;
  background: #f2edff;
  border: 1px solid #f2edff;
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #6941c6;
  text-decoration: none;
  cursor: pointer;
}

.phone-task-state__action:focus-visible {
  outline: 2px solid #7f56d9;
  outline-offset: 2px;
}
</style>
